import { element, bool, string, node } from 'prop-types'
import { Button, Tooltip } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

const wrapperCss = (fullWidth) => css`
  position: relative;
  display: inline-block;
  ${fullWidth && `width: 100%;`}
`

const tooltipCss = (theme) => css`
  display: block;
  width: max-content;
  min-width: 200px;
  max-width: 262px;

  > a.link {
    color: ${theme.colors.cornflowerBlue};
    display: initial;
    padding: 0;

    &:hover {
      color: ${theme.colors.cornflowerBlueHover};
    }
  }

  p {
    white-space: pre-line;
  }
`

const buttonCss = (theme) => css`
  opacity: 0.65;
  cursor: not-allowed;

  &:hover {
    background-color: ${theme.colors.blue};
    border-color: ${theme.colors.blue};
  }
`

const NotInstallableButton = ({
  icon,
  className,
  fullWidth,
  children,
  label,
  size = 'large',
}) => (
  <div css={wrapperCss(fullWidth)}>
    <Tooltip
      css={tooltipCss}
      zIndex={100}
      triggerRenderer={() => (
        <Button
          kind="primary"
          icon={icon}
          className={className}
          fullWidth={fullWidth}
          size={size}
          css={buttonCss}
        >
          {label || 'Get'}
        </Button>
      )}
    >
      {children}
    </Tooltip>
  </div>
)

NotInstallableButton.propTypes = {
  icon: element,
  children: node,
  className: string,
  fullWidth: bool,
  size: string,
  label: string,
}

export default NotInstallableButton
